module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Mask-f6aa688730fd1d73c306779f2f59dd22.svg";